import HomeLayouts from "./HomeLayouts/HomeLayouts";
import RootLayouts from "./Rootlayouts/Rootlayouts";

export { HomeLayouts, RootLayouts };
